import { LoadMediaInView } from '@polestar/component-warehouse-react/components/in-view/InView';
import React from 'react';
import Picture from '@polestar/component-warehouse-react/components/picture/Picture';
import { GallerySlideTypes, GalleryVariants } from '../Gallery';
import { VideoSlide } from './GallerySlides';
import { SectionInner } from '@polestar/component-warehouse-react/components/section/Section';
import AspectRatio from '@polestar/component-warehouse-react/components/aspect-ratio/AspectRatio';
import Image from '@polestar/component-warehouse-react/components/image/Image';
import TextIndicator from './GalleryTextIndicator';
import styled from '@emotion/styled';
const SingleItem = ({ content, variant, aspectRatio, inBreakoutSection, captions, showCaption, clampedIndex, ref, }) => {
    const singleItem = content;
    const stretchProps = singleItem.type === GallerySlideTypes.video
        ? {}
        : variant === GalleryVariants.contained
            ? {
                style: {
                    height: '100%',
                    width: 'auto',
                    maxWidth: 'none',
                },
            }
            : {
                stretch: true,
                objectFit: 'cover',
            };
    const { style: stretchStyle, ...stretchWithoutStyleProps } = stretchProps;
    const SectionWrapper = inBreakoutSection ? SectionInner : React.Fragment;
    const AspectWrapper = aspectRatio ? AspectRatio : React.Fragment;
    const aspectWrapperProps = aspectRatio ? { ratio: aspectRatio } : {};
    if (singleItem.type === GallerySlideTypes.video) {
        return (React.createElement(LoadMediaInView, { offset: "0px 0px -60% 0px", triggerOnce: true },
            React.createElement(Wrapper, { ref: ref },
                React.createElement(AspectWrapper, { ...aspectWrapperProps },
                    React.createElement(VideoWrapper, null,
                        React.createElement(VideoSlide, { key: 0, ...singleItem, contentLength: 1, index: 0, style: {
                                x: undefined,
                                ...stretchStyle,
                            }, isDark: singleItem.isDark }))))));
    }
    else {
        const { pictureProps, sources, source, style, ...imgProps } = singleItem;
        return (React.createElement(LoadMediaInView, { offset: "0px 0px -60% 0px", triggerOnce: true },
            React.createElement(Wrapper, { ref: ref },
                React.createElement(AspectWrapper, { ...aspectWrapperProps },
                    React.createElement(Picture, { ...pictureProps, stretch: true }, sources === null || sources === void 0 ? void 0 :
                        sources.map((source, sourceIndex) => (React.createElement("source", { key: `source${sourceIndex}`, ...source }))),
                        React.createElement(Image, { src: source || (imgProps === null || imgProps === void 0 ? void 0 : imgProps.src), alt: imgProps === null || imgProps === void 0 ? void 0 : imgProps.alt, ...stretchWithoutStyleProps, ...imgProps, style: {
                                ...style,
                                ...stretchStyle,
                                x: undefined,
                            } })),
                    showCaption && (React.createElement(SectionWrapper, null,
                        React.createElement(TextIndicator, { clampedIndex: clampedIndex, length: 1, captions: captions, "data-type": "indicator", variant: variant })))))));
    }
};
SingleItem.displayName = 'SingleItem';
export default SingleItem;
const Wrapper = styled.div `
  width: 100%;
  display: flex;
  position: relative;
`;
const VideoWrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;
